import {EMPTY} from '@web3-react/empty';
import {
  useConnectEagerly,
  useConnector,
  useInitializeConnector,
} from '../hooks';
import {useCallback, useEffect} from 'react';
import {Web3ConnectionType} from '../types';
import {BaseConnectorProps} from './types';

export const Empty = ({
  onStateUpdate,
  onConnectorUpdate,
}: BaseConnectorProps) => {
  const connector = useInitializeConnector(
    Web3ConnectionType.EMPTY,
    useCallback(() => EMPTY, [])
  );

  useEffect(() => {
    onConnectorUpdate(connector.connector);
  }, [connector.connector, onConnectorUpdate]);

  useConnector(connector, onStateUpdate);

  useConnectEagerly(connector.connector, Web3ConnectionType.EMPTY);

  return null;
};
